// Product name translations and typo fixes
// Maps English names or typos to correct Swedish names

const translations: Record<string, string> = {
  // English to Swedish
  'Brake caliper motor': 'Bromsokmotor',
  'Brake caliper': 'Bromsok',
  'Brake pads': 'Bromsbelägg',
  'Brake disc': 'Bromsskiva',
  'Brake hose': 'Bromsslang',
  'Brake shoe': 'Bromsbacke',
  'ABS sensor': 'ABS-givare',
  'Wheel speed sensor': 'Hjulvarvssensor',
  'Clutch kit': 'Kopplingssats',
  'Clutch disc': 'Lamell',
  'Pressure plate': 'Tryckplatta',
  'Release bearing': 'Urkopplingslager',
  'Shock absorber': 'Stötdämpare',
  'Coil spring': 'Spiralfjäder',
  'Control arm': 'Länkarm',
  'Ball joint': 'Kulled',
  'Tie rod end': 'Styrled',
  'Tie rod': 'Spårstång',
  'Stabilizer link': 'Krängningshämmare',
  'Wheel bearing': 'Hjullager',
  'CV joint': 'Drivknut',
  'Drive shaft': 'Drivaxel',
  'Water pump': 'Vattenpump',
  'Thermostat': 'Termostat',
  'Radiator': 'Kylare',
  'Radiator hose': 'Kylarslang',
  'Coolant sensor': 'Kylvätskegivare',
  'Oil filter': 'Oljefilter',
  'Air filter': 'Luftfilter',
  'Fuel filter': 'Bränslefilter',
  'Cabin filter': 'Kupefilter',
  'Spark plug': 'Tändstift',
  'Ignition coil': 'Tändspole',
  'Timing belt': 'Kamrem',
  'Timing belt kit': 'Kamremssats',
  'Alternator': 'Generator',
  'Starter motor': 'Startmotor',
  'Wiper blade': 'Torkarblad',
  'Wiper arm': 'Torkararm',
  'Headlight': 'Strålkastare',
  'Tail light': 'Bakljus',
  'Turn signal': 'Blinkers',
  'Mirror': 'Spegel',
  'Door handle': 'Dörrhandtag',
  'Window regulator': 'Fönsterhiss',
  'Exhaust pipe': 'Avgasrör',
  'Muffler': 'Ljuddämpare',
  'Catalytic converter': 'Katalysator',
  'Lambda sensor': 'Lambdasond',
  'Oxygen sensor': 'Syresensor',
  'MAP sensor': 'MAP-givare',
  'MAF sensor': 'Luftmassemätare',
  'Throttle body': 'Trottelhus',
  'EGR valve': 'EGR-ventil',
  'Turbocharger': 'Turbo',
  'Intercooler': 'Laddluftkylare',
  'Piston': 'Kolv',
  
  // Typo fixes
  'Sendor, insugstryck': 'Sensor, insugstryck',
  'Sendor': 'Sensor',
  
  // Other common corrections
  'Caliper piston': 'Kolvbromsok',
  'Caliper repair kit': 'Bromsokreparsats',
};

// Case-insensitive lookup
const translationsLower = Object.fromEntries(
  Object.entries(translations).map(([k, v]) => [k.toLowerCase(), v])
);

export function translateProductName(name: string): string {
  if (!name) return name;
  
  // Try exact match first
  if (translations[name]) {
    return translations[name];
  }
  
  // Try case-insensitive match
  const lowerName = name.toLowerCase();
  if (translationsLower[lowerName]) {
    return translationsLower[lowerName];
  }
  
  // Try partial match for typos (Sendor -> Sensor)
  let correctedName = name;
  for (const [typo, correct] of Object.entries(translations)) {
    if (name.includes(typo)) {
      correctedName = correctedName.replace(typo, correct);
    }
  }
  
  return correctedName;
}

export default translateProductName;
